const env = process.env.REACT_APP_NODE_ENV;

const apiConfig = {
  dev: {
   API_BASE: 'https://web-production-f24f2.up.railway.app',
   API_PAGOS: "https://www.flow.cl/btn.php?token=wf4039c6224d8febfe3187735462ccc3484859fe"
  // API_BASE: 'http://localhost:5000',
  // API_BASE_BIOMAP: 'https://web-production-f24f2.up.railway.app',
  // API_BASE_CONSULTING: 'https://biomapserver-production.up.railway.app',
  },
  prod: {
    API_BASE: 'https://server-production-a29c.up.railway.app',
  },
  testing: {
    API_BASE: 'https://server-production-a29c.up.railway.app',
  },
  env,
};


export default apiConfig;